import { render } from "./MobileRouteWrapper.component.vue?vue&type=template&id=48c3b007&scoped=true"
import script from "./MobileRouteWrapper.component.vue?vue&type=script&lang=js"
export * from "./MobileRouteWrapper.component.vue?vue&type=script&lang=js"

import "./MobileRouteWrapper.component.vue?vue&type=style&index=0&id=48c3b007&lang=scss&scoped=true"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-48c3b007"]])

export default __exports__